import { createAction, handleActions } from "redux-actions";
import { updateVocabularyAPI } from "@modules/apis/vocabulary";
import {
    getReportCurrentEmailRecipientsAPI,
    getReportsAPI,
    getReportSettingAPI,
    getReportSettingsAPI,
    updateReportCurrentEmailRecipientsAPI,
    updateReportSettingsAPI,
} from "@modules/apis/reports";
import { merge } from "lodash";
import { getReportAPI, getReportEmailRecipientsAPI } from "@modules/apis/report";

const initialState = {
    data: null,
    pending: false,
    error: false,
};

const GET_REPORT_PENDING = "GET_REPORT_PENDING";
const GET_REPORT_SUCCESS = "GET_REPORT_SUCCESS";
const GET_REPORT_FAILURE = "GET_REPORT_FAILURE";
const RESET_REPORT = "RESET_REPORT";
const UPDATE_TOTAL_COUNT_BY_PROJECT = "UPDATE_TOTAL_COUNT_BY_PROJECT";

export default handleActions(
    {
        [GET_REPORT_PENDING]: (state) => {
            return { ...state, pending: true, data: null, error: false };
        },
        [GET_REPORT_SUCCESS]: (state, action) => {
            return { ...state, data: action.payload, pending: false };
        },
        [GET_REPORT_FAILURE]: (state, action) => {
            return { ...state, pending: false, error: action.payload };
        },
        [RESET_REPORT]: (state) => {
            return { ...initialState };
        },
        [UPDATE_TOTAL_COUNT_BY_PROJECT]: (state, action) => {
            return { ...state, data: { ...state.data, totalCount: action.payload } };
        },
    },
    initialState,
);

const calculateTotalCountByProject = (aggregations) => {
    const result = {};

    aggregations.forEach((item) => {
        // project.id가 없으면 'Total', 있으면 project.id 사용
        const projectId = item.project ? item.project.id : "All";
        const condition = item.condition;

        // result에 projectId가 없으면 초기화
        if (!result[projectId]) {
            result[projectId] = {};
        }

        const totalValue = item.data.reduce((sum, entry) => sum + BigInt(entry.value), BigInt(0));

        if (result[projectId][condition])
            result[projectId][condition] = (BigInt(result[projectId][condition]) + totalValue).toString();
        else result[projectId][condition] = totalValue.toString();
    });

    return result;
};

export const getReport =
    ({ projectId, reportId, params }) =>
    (dispatch, getState) => {
        const { stage } = getState();

        return new Promise(async (resolve, reject) => {
            try {
                dispatch({ type: GET_REPORT_PENDING });

                const response = await getReportAPI(stage.id, stage.endpoint, projectId, reportId);

                let recipientsNextToken = null;
                const recipients = [];
                do {
                    const recipientsResponse = await getReportEmailRecipientsAPI(
                        stage.id,
                        stage.endpoint,
                        projectId,
                        response.data.id,
                    );
                    recipientsNextToken = recipientsResponse.data.nextToken;
                    recipients.push(...recipientsResponse.data.results);
                } while (!!recipientsNextToken);

                response.data.recipients = recipients;
                response.data.target.totalCountAggregations = calculateTotalCountByProject(
                    response.data?.target?.aggregations,
                );

                if (response.data?.lastReport?.id) {
                    const lastReportResponse = await getReportAPI(
                        stage.id,
                        stage.endpoint,
                        projectId,
                        response.data?.lastReport?.id,
                    );

                    response.data.target.lastTotalCountAggregations = calculateTotalCountByProject(
                        lastReportResponse.data?.target?.aggregations,
                    );
                    response.data.lastSummaries = lastReportResponse.data.summaries;
                }

                dispatch({
                    type: GET_REPORT_SUCCESS,
                    payload: response.data,
                });

                resolve(response.data?.nextToken);
            } catch (error) {
                dispatch({ type: GET_REPORT_FAILURE, payload: error });
                reject(error);
            }
        });
    };
